import { Button } from "antd";

import ButtonLink from "@/modules/button-link";
import { useModelLinkInline } from "@/modules/model-link";
import { usePageModalLocationState } from "@/modules/page-modal";
import { Tooltip } from "@/ui/tooltip";

const PageModalNavigationItem = ({ icon, model, item, formatTitle }) => {
  const { backgroundList, backgroundLocation } = usePageModalLocationState();
  const modelLink = useModelLinkInline(model, item);
  const uiProps = { shape: "circle", icon };

  if (!item) return <Button {...uiProps} disabled />;

  return (
    <Tooltip title={formatTitle ? formatTitle(item) : item.name}>
      <ButtonLink
        {...uiProps}
        inModal
        to={modelLink}
        modalState={{
          showLoaderInModal: true,
          backgroundList, // keep the list context for the previous/next items
          backgroundLocation, // force go back to original backgroundLocation on modal closed
        }}
      />
    </Tooltip>
  );
};

export default PageModalNavigationItem;
